import React, { PureComponent } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import Card from '../../components/Card/Card';
import OwlCarousel from '../../components/OwlCarousel/OwlCarousel';
import IntroCategoryBlock from './IntroCategoryBlock';
import { STATIC_PATH } from '../../config';

const carouselSettings = {
  loop: false,
  nav: false,
  margin: 0,
  className: 'owl-theme owl-footer-dots',
  mouseDrag: true,
  touchDrag: true,
  responsive: {
    0: {
      items: 1,
    },

    480: {
      items: 2,
    },

    768: {
      items: 2,
    },

    991: {
      items: 3,
    },

    1343: {
      items: 4,
    },
  },
};

const path = `${STATIC_PATH}/img/categories`;

class IntroWidget extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      introItems: [
        {
          img: `${this.getThemedIntroItemImgPath()}/vip.svg`,
          title: 'Exclusive offers',
          link: '/offers/all?categories=8',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/post.svg`,
          title: 'COD',
          link: '/offers/all?categories=14,12,18,23,40,16,20,22,15,21,17,19,1',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/shop.svg`,
          title: 'Online Stores',
          link: '/offers/all?categories=10',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/financy.svg`,
          title: 'Finances and cryptocurrencies',
          link: '/offers/all?categories=41,30,29,26,28,25,24,2',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/study.svg`,
          title: 'Education',
          link: '/offers/all?categories=3',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/game.svg`,
          title: 'Games and entertainments',
          link: '/offers/all?categories=31,32,4',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/adult.svg`,
          title: 'Adult',
          link: '/offers/all?categories=9',
        },
        {
          img: `${this.getThemedIntroItemImgPath()}/white.svg`,
          title: 'Other',
          link: '/offers/all?categories=11',
        },
      ],
    };
  }

  getThemedIntroItemImgPath = () => {
    const { theme } = this.props;
    switch (theme) {
      case 3:
        return `${path}/theme-3`;
      default:
        return path;
    }
  }

  splitCategories = () => {
    const { introItems } = this.state;

    if (introItems.length) {
      const result = [];

      for (let i = 0; i < introItems.length; i++) {
        if (introItems.length > 2 && introItems[i + 1]) {
          result.push([introItems[i], introItems[++i]]);
        } else {
          result.push([introItems[i]]);
        }
      }

      return result;
    }
  }

  render() {
    // const { introItems } = this.state;
    const { collapsing, localStorageName } = this.props;
    const formattedCategories = this.splitCategories();
    return (
      <Card className="intro-widget" localStorageName={localStorageName} collapsing={collapsing}>
        <Card.Header>
          <span className="intro-widget-title">
            <FormattedMessage id="intro.title" defaultMessage="Start working with offerrum" />
          </span>
          {/* <Button color="primary" outline className="intro-widget-skip-btn float-right">
            <FormattedMessage id="intro.skip_button" defaultMessage="Skip Intro"/>
          </Button> */}
        </Card.Header>
        <Card.Body>
          <p className="lead">
            <FormattedHTMLMessage
              id="intro.header"
              defaultMessage="What is&nbsp;your vertical of&nbsp;choice?"
              tagName="span"
            />
          </p>
          <OwlCarousel {...carouselSettings}>
            {formattedCategories.map((item, index) => (
              <IntroCategoryBlock key={`intro_widget_block_${index}`} item={item} />
            ))}
          </OwlCarousel>
        </Card.Body>
      </Card>
    );
  }
}

const mapStateToProps = ({ webmaster }) => ({
  theme: webmaster.profile.theme,
});

export default connect(mapStateToProps)(IntroWidget);
